// Traduções comuns do HubVerticalFarm (02/11/2026): os
// rótulos dos tipos de `comum/tipos.ts`, para todo módulo dizer o mesmo. Coletadas
// por glob em core/i18n/messages.ts.
export default {
  pt: {
    'farm.imovel.tipo.fazenda': 'Fazenda',
    'farm.imovel.tipo.sitio': 'Sítio',
    'farm.imovel.tipo.area': 'Área',
    'farm.imovel.tipo.confinamento': 'Confinamento',
    'farm.imovel.atividade.graos': 'Grãos',
    'farm.imovel.atividade.confinamento': 'Confinamento',
    'farm.imovel.atividade.silvicultura_carvao': 'Silvicultura e carvão',
    'farm.imovel.atividade.lazer': 'Lazer',
    'farm.imovel.atividade.arrendado_terceiro': 'Arrendado a terceiro',
    'farm.imovel.situacao.fundo_arrendamento': 'Do fundo, em arrendamento',
    'farm.imovel.situacao.propria': 'Própria',
    'farm.imovel.situacao.arrendada_terceiro': 'Arrendada a terceiro',
    'farm.imovel.status.ativo': 'Ativo',
    'farm.imovel.status.inativo': 'Inativo',
    'farm.car.situacao.ativo': 'Ativo',
    'farm.car.situacao.pendente': 'Pendente',
    'farm.car.situacao.em_analise': 'Em análise',
    'farm.car.situacao.cancelado': 'Cancelado',
    'farm.car.semSituacao': 'Situação não informada',
    'farm.marca.agri8': 'Agri8',
    'farm.marca.segredo': 'Segredo',
    'farm.marca.semMarca': 'Sem marca',
  },
  en: {
    'farm.imovel.tipo.fazenda': 'Farm',
    'farm.imovel.tipo.sitio': 'Small farm',
    'farm.imovel.tipo.area': 'Land',
    'farm.imovel.tipo.confinamento': 'Feedlot',
    'farm.imovel.atividade.graos': 'Grains',
    'farm.imovel.atividade.confinamento': 'Feedlot',
    'farm.imovel.atividade.silvicultura_carvao': 'Forestry and charcoal',
    'farm.imovel.atividade.lazer': 'Leisure',
    'farm.imovel.atividade.arrendado_terceiro': 'Leased to a third party',
    'farm.imovel.situacao.fundo_arrendamento': 'Fund owned, leased',
    'farm.imovel.situacao.propria': 'Owned',
    'farm.imovel.situacao.arrendada_terceiro': 'Leased to a third party',
    'farm.imovel.status.ativo': 'Active',
    'farm.imovel.status.inativo': 'Inactive',
    'farm.car.situacao.ativo': 'Active',
    'farm.car.situacao.pendente': 'Pending',
    'farm.car.situacao.em_analise': 'Under review',
    'farm.car.situacao.cancelado': 'Cancelled',
    'farm.car.semSituacao': 'Status not informed',
    'farm.marca.agri8': 'Agri8',
    'farm.marca.segredo': 'Segredo',
    'farm.marca.semMarca': 'No brand',
  },
  es: {
    'farm.imovel.tipo.fazenda': 'Hacienda',
    'farm.imovel.tipo.sitio': 'Finca',
    'farm.imovel.tipo.area': 'Terreno',
    'farm.imovel.tipo.confinamento': 'Engorde a corral',
    'farm.imovel.atividade.graos': 'Granos',
    'farm.imovel.atividade.confinamento': 'Engorde a corral',
    'farm.imovel.atividade.silvicultura_carvao': 'Silvicultura y carbón',
    'farm.imovel.atividade.lazer': 'Ocio',
    'farm.imovel.atividade.arrendado_terceiro': 'Arrendado a terceros',
    'farm.imovel.situacao.fundo_arrendamento': 'Del fondo, en arrendamiento',
    'farm.imovel.situacao.propria': 'Propia',
    'farm.imovel.situacao.arrendada_terceiro': 'Arrendada a terceros',
    'farm.imovel.status.ativo': 'Activo',
    'farm.imovel.status.inativo': 'Inactivo',
    'farm.car.situacao.ativo': 'Activo',
    'farm.car.situacao.pendente': 'Pendiente',
    'farm.car.situacao.em_analise': 'En análisis',
    'farm.car.situacao.cancelado': 'Cancelado',
    'farm.car.semSituacao': 'Situación no informada',
    'farm.marca.agri8': 'Agri8',
    'farm.marca.segredo': 'Segredo',
    'farm.marca.semMarca': 'Sin marca',
  },
}
